module.exports = __webpack_public_path__ + "img/ServicioAgricultura.5b94be9e.png";